import { matchCommandPaletteQuery, type CommandPaletteMatch } from "./commandPaletteMatch";
import type { CommandPaletteDestination } from "./commandPaletteDestinations";

export type RankedCommandPaletteDestination = CommandPaletteDestination & {
  match: CommandPaletteMatch;
  catalogIndex: number;
};

export function rankCommandPaletteDestinations(
  destinations: CommandPaletteDestination[],
  query: string
): RankedCommandPaletteDestination[] {
  const trimmed = query.trim();

  const ranked = destinations.flatMap((destination, catalogIndex) => {
    const match = matchCommandPaletteQuery(trimmed, destination.label, destination.breadcrumbs, destination.keywords);
    if (!match) return [];
    return [{ ...destination, match, catalogIndex }];
  });

  ranked.sort((a, b) => {
    if (trimmed) {
      if (b.match.score !== a.match.score) return b.match.score - a.match.score;
    }

    const depthA = a.breadcrumbs.length;
    const depthB = b.breadcrumbs.length;
    if (depthA !== depthB) return depthA - depthB;
    return a.catalogIndex - b.catalogIndex;
  });

  return ranked;
}
